import baseApi from "./baseApi.js";
import axios from '@/models/API/axios'
import * as apiUrl from './apiUrl.js';

/**
 * 業務api
 */
class businessApi extends baseApi {
    constructor() {
        super();
        this.baseApi = new baseApi();
    }

    /**
     * 查詢業務
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 查詢參數
     */
    getSales(callback = {}, params = {}) {
        const options = {
            method: this.request.method.get,
            url: `${apiUrl.API_GET_SALES}`,
            params: params,
            is_loading: true,
            headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
        };
        axios(options).then((response) => {
            callback(response);
        }).catch((err) => {
            callback(err.response);
        });
    }

    /**
     * 新增業務
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 新增參數
     */
    addSales(callback = {}, params = {}) {
        const options = {
            method: this.request.method.post,
            url: `${apiUrl.API_POST_SALES}`,
            data: params,
            is_loading: true,
            headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
        };
        axios(options).then((response) => {
            callback(response);
        }).catch((err) => {
            callback(err.response);
        });
    }

    /**
     * 更新業務
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 更新參數
     */
    updateSales(callback = {}, params = {}) {
        const options = {
            method: this.request.method.put,
            url: `${apiUrl.API_PUT_SALES}/${params.id}`,
            data: params,
            is_loading: true,
            headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
        };
        axios(options).then((response) => {
            callback(response);
        }).catch((err) => {
            callback(err.response);
        });
    }

    /**
     * 刪除業務
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} id 刪除參數
     */
    deleteSales(callback = {}, id = {}) {
        const options = {
            method: this.request.method.delete,
            url: `${apiUrl.API_DELETE_SALES}/${id}`,
            is_loading: true,
            headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
        };
        axios(options).then((response) => {
            callback(response);
        }).catch((err) => {
            callback(err.response);
        });
    }

    /**
     * 匯出業務EXCEL
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 查詢參數
     */
    exportSales(callback = {}, params = {}) {
        const options = {
            method: this.request.method.get,
            url: `${apiUrl.API_GET_EXPORT_SALES}`,
            params: params,
            is_loading: true,
            responseType: "blob",
            headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
        };
        axios(options).then((response) => {
            callback(response);
        }).catch((err) => {
            callback(err.response);
        });
    }

    /**
     * 查詢業務上層樹狀圖
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 查詢參數
     */
     getSalesUpperTree(callback = {}, params = {}) {
        const options = {
          method: this.request.method.post,
          url: `${apiUrl.API_POST_SALES_UPPER_TREE}`,
          params: params,
          is_loading: true,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
        };
        axios(options).then((response) => {
            callback(response);
        }).catch((err) => {
            callback(err.response);
        });
    }

    /**
     * 查詢業務下層樹狀圖
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 查詢參數
     */
    getSalesLowerTree(callback = {}, params = {}) {
      const options = {
      method: this.request.method.post,
      url: `${apiUrl.API_POST_SALES_LOWER_TREE}`,
      params: params,
      is_loading: true,
      headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

    /**
     * 查詢業務LOG
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 查詢參數
     */
    getSalesLogs(callback = {}, params = {}) {
      const options = {
          method: this.request.method.get,
          url: `${apiUrl.API_GET_SALES_LOGS}`,
          params: params,
          is_loading: true,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

}

export default businessApi;



// WEBPACK FOOTER //
// ./src/models/API/businessApi.js